import InvestmentDetailsPage from "./InvestmentDetailsPage";

export default InvestmentDetailsPage;
